import { useSelector } from 'react-redux';

import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { PersistConfig, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

interface FlagsState {
  flags: Record<string, boolean>;
}

const persistConfig: PersistConfig<FlagsState> = {
  key: 'flags',
  storage,
  version: CACHE_STORE_VERSION,
};

const initialState: FlagsState = {
  flags: {},
};

export const flagsSlice = createSlice({
  name: 'flags',
  initialState,
  reducers: {
    toggleFlag(state, action: PayloadAction<string>) {
      if (state.flags[action.payload] === true) {
        delete state.flags[action.payload];
      } else {
        state.flags[action.payload] = true;
      }
    },
  },
  selectors: {
    selectFlags: (state: FlagsState) => state.flags,
  },
});

export const flagSelector = (flag: string) => (state: FlagsState) =>
  state.flags[flag] || false;

export const useFlagState = (flag: string) => {
  const flags = useSelector(flagsSlice.selectors.selectFlags);

  return flags[flag] || false;
};

export const flagsPersistedReducer = persistReducer(
  persistConfig,
  flagsSlice.reducer,
);
